const localBrand = {name: process.env.REACT_APP_BRAND} 

module.exports = global.config = {
  brand: localBrand.name,
  isBrandMX: localBrand.name === "Maxxia", 
  isBrandRS: localBrand.name === "RemServ" 
}
